import { PureComponent } from "react";

import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";

import { StyledSimpleColorfulTitleWithSignupComponent } from "./simple-colorful-title-with-signup-component.scss";

export default class SimpleColorfulTitleWithSignupComponent extends PureComponent {
  render() {
    const { title, subtitle, signupForm, showDecorations, showSignup, isFirstSegment } = this.props;
    return (
      <StyledSimpleColorfulTitleWithSignupComponent className="simple-colorful-title-with-signup-component">
        <div className="title-wrapper">
          <ParagraphComponent title={title} isFirstSegment={isFirstSegment} />
        </div>

        {subtitle && (
          <div className="subtitle-wrapper">
            {typeof subtitle === "function" ? subtitle() : <h2 dangerouslySetInnerHTML={{ __html: subtitle }} />}
          </div>
        )}

        {showSignup && (
          <div className="signup-form-with-decorations-wrapper">
            <SignupFormComponent {...signupForm} showDecorations={showDecorations} />
          </div>
        )}
      </StyledSimpleColorfulTitleWithSignupComponent>
    );
  }
}

SimpleColorfulTitleWithSignupComponent.defaultProps = {
  title: "Start celebrating success. <brand-blue>Try for free</end>.",
  showSignup: true,
  isFirstSegment: false
};
